import upperFirst from 'lodash/upperFirst'

import i18n from 'modules/core/lib/i18n'

import { UPDATE_FREQUENCY } from 'modules/attendance/lib/enums'

export const handleUpdateFrequencyI18n = (frequency: string): string => {
  if (frequency === UPDATE_FREQUENCY.daily) {
    return upperFirst(
      i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.update_frequency.daily'
      )
    )
  }
  if (frequency === UPDATE_FREQUENCY.weekly) {
    return upperFirst(
      i18n.t(
        'time_tracking.settings.overtime.compensation.timeoff.form.fields.update_frequency.weekly'
      )
    )
  }

  return upperFirst(
    i18n.t(
      'time_tracking.settings.overtime.compensation.timeoff.form.fields.update_frequency.monthly'
    )
  )
}
